(() => {
  const desktop = window.matchMedia('(min-width: 768px)');
  let renderQueued = false;

  const findLegacyAnchor = () => {
    if (!document.body || !window.NodeFilter) return null;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_COMMENT);
    let node = walker.nextNode();
    while (node) {
      if ((node.nodeValue || '').trim() === 'AO details original position') return node;
      node = walker.nextNode();
    }
    return null;
  };

  const findSource = () => Array.from(document.querySelectorAll('.aoepd')).find((node) => !node.hasAttribute('data-ao-details-clone')) || null;

  const repairLegacyPlacement = () => {
    const root = document.querySelector('.ao-marketplace');
    const source = findSource();
    if (!root || !source) return false;
    const mainWrapper = root.closest('[id^="shopify-section-"]');
    const sourceWrapper = source.closest('[id^="shopify-section-"]');
    if (!mainWrapper || !sourceWrapper || sourceWrapper === mainWrapper || !mainWrapper.contains(sourceWrapper)) return false;
    const anchor = findLegacyAnchor();
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(sourceWrapper, anchor.nextSibling);
      anchor.remove();
    } else if (mainWrapper.parentNode) {
      mainWrapper.parentNode.insertBefore(sourceWrapper, mainWrapper.nextSibling);
    }
    return true;
  };

  const ensureMediaLayout = () => {
    const root = document.querySelector('.ao-marketplace');
    if (!root) return null;
    const media = root.querySelector('.ao-marketplace-media');
    if (!media) return null;
    let gallery = Array.from(media.children).find((node) => node.classList.contains('ao-marketplace-gallery-shell'));
    let slot = Array.from(media.children).find((node) => node.hasAttribute('data-ao-details-slot'));
    if (!gallery) {
      gallery = document.createElement('div');
      gallery.className = 'ao-marketplace-gallery-shell product--images';
      const existingNodes = Array.from(media.childNodes).filter((node) => node !== slot);
      existingNodes.forEach((node) => gallery.appendChild(node));
      media.classList.remove('product--images', 'product-single__sticky');
      media.insertBefore(gallery, slot || null);
    } else {
      media.classList.remove('product--images', 'product-single__sticky');
      gallery.classList.add('product--images');
      gallery.classList.remove('product-single__sticky');
    }
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'ao-marketplace-details-slot';
      slot.setAttribute('data-ao-details-slot', '');
      media.appendChild(slot);
    }
    return { root, media, gallery, slot };
  };

  const clearPlacement = () => {
    document.querySelectorAll('[data-ao-details-clone]').forEach((node) => node.remove());
    document.querySelectorAll('.ao-details-source--placed').forEach((node) => node.classList.remove('ao-details-source--placed'));
  };

  const render = () => {
    renderQueued = false;
    repairLegacyPlacement();
    const layout = ensureMediaLayout();
    const source = findSource();
    if (!layout || !source) return;
    const sourceWrapper = source.closest('[id^="shopify-section-"]') || source;
    document.querySelectorAll('.ao-details-source--placed').forEach((node) => {
      if (node !== sourceWrapper) node.classList.remove('ao-details-source--placed');
    });
    if (desktop.matches) {
      const clone = source.cloneNode(true);
      clone.setAttribute('data-ao-details-clone', '');
      layout.slot.replaceChildren(clone);
      sourceWrapper.classList.add('ao-details-source--placed');
    } else {
      layout.slot.replaceChildren();
      sourceWrapper.classList.remove('ao-details-source--placed');
    }
  };

  const queueRender = () => {
    if (renderQueued) return;
    renderQueued = true;
    requestAnimationFrame(render);
  };

  const boot = () => {
    render();
    queueRender();
    const observer = new MutationObserver(() => {
      const root = document.querySelector('.ao-marketplace');
      const source = findSource();
      if (!root || !source) return;
      const mainWrapper = root.closest('[id^="shopify-section-"]');
      const sourceWrapper = source.closest('[id^="shopify-section-"]');
      if (mainWrapper && sourceWrapper && sourceWrapper !== mainWrapper && mainWrapper.contains(sourceWrapper)) {
        repairLegacyPlacement();
        queueRender();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  if (desktop.addEventListener) desktop.addEventListener('change', queueRender);
  else desktop.addListener(queueRender);
  document.addEventListener('shopify:section:unload', () => {
    clearPlacement();
    window.setTimeout(queueRender, 0);
  });
  document.addEventListener('shopify:section:load', () => window.setTimeout(queueRender, 0));
})();

/* AO mobile PDP purchase-priority experiment. Unpublished preview only. */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const movedSelectors = [
    '.ao-marketplace-header',
    '.ao-wm-price-zone',
    '.ao-wm-selection',
    '.ao-wm-cart-zone',
    '.ao-marketplace-features'
  ];

  const restore = (root = document) => {
    root.querySelectorAll('[data-ao-mobile-purchase-anchor]').forEach((anchor) => {
      const key = anchor.getAttribute('data-ao-mobile-purchase-anchor');
      const node = document.querySelector(`[data-ao-mobile-purchase-node="${key}"]`);
      if (node && anchor.parentNode) {
        anchor.parentNode.insertBefore(node, anchor.nextSibling);
        node.removeAttribute('data-ao-mobile-purchase-node');
      }
      anchor.remove();
    });
    root.querySelectorAll('[data-ao-mobile-purchase-priority]').forEach((node) => node.remove());
    root.querySelectorAll('[data-ao-mobile-purchase-node]').forEach((node) => node.removeAttribute('data-ao-mobile-purchase-node'));
  };

  const renderMobilePriority = () => {
    const root = document.querySelector('.ao-marketplace');
    if (!root) return;
    restore(document);
    if (!mobile.matches) return;
    const grid = root.querySelector('.ao-marketplace-grid');
    const media = grid && grid.querySelector(':scope > .ao-marketplace-media');
    const header = root.querySelector('.ao-marketplace-header');
    const price = root.querySelector('.ao-marketplace-buybox .ao-wm-price-zone');
    const cart = root.querySelector('.ao-marketplace-buybox .ao-wm-cart-zone');
    if (!grid || !media || !header || !price || !cart) return;
    const priority = document.createElement('div');
    priority.className = 'ao-mobile-purchase-priority';
    priority.setAttribute('data-ao-mobile-purchase-priority', '');
    movedSelectors.forEach((selector, index) => {
      const node = root.querySelector(selector);
      if (!node || !node.parentNode) return;
      const key = String(index);
      const anchor = document.createElement('span');
      anchor.hidden = true;
      anchor.setAttribute('data-ao-mobile-purchase-anchor', key);
      node.parentNode.insertBefore(anchor, node);
      node.setAttribute('data-ao-mobile-purchase-node', key);
      priority.appendChild(node);
    });
    grid.insertBefore(priority, media);
  };

  let queued = false;
  const queueMobileRender = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      renderMobilePriority();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueMobileRender, { once: true });
  else queueMobileRender();
  if (mobile.addEventListener) mobile.addEventListener('change', queueMobileRender);
  else mobile.addListener(queueMobileRender);
  document.addEventListener('shopify:section:load', queueMobileRender);
  document.addEventListener('shopify:section:unload', () => restore(document));
})();
